"use client";

import { QueryClientProvider as TanstackQueryClientProvider } from "@tanstack/react-query";
import React from "react";
import { QUERY_CLIENT } from "./consts";
import type { QueryClientProviderProperties } from "./types";

function QueryClientProvider({ children }: QueryClientProviderProperties) {
  return (
    <TanstackQueryClientProvider client={QUERY_CLIENT}>
      {children}
    </TanstackQueryClientProvider>
  );
}

export default React.memo(QueryClientProvider);
